const AppConfig = {
  auth: {
    isLoggedIn: 'loggedInLaoTV',
    accessToken: 'accessTokenLaoTV',
    userRole: 'userRole',
  }
}

export default AppConfig;
